import type { Tenant } from '../../../types/domain';

export function OverviewTab({ tenant }: { tenant: Tenant }) {
  const t = tenant as Tenant & {
    registrationNumber?: string | null;
    jbkjs?: string | null;
    address?: string | null;
    city?: string | null;
    country?: string | null;
  };

  const fullAddress = [t.address, t.city, t.country].filter(Boolean).join(', ');

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
      <Section title="Identifikacija">
        <KV label="Naziv" value={t.name} />
        <KV label="PIB" value={t.taxId || '-'} />
        <KV label="Matični broj (MB)" value={t.registrationNumber || '-'} />
        <KV label="JBKJS" value={t.jbkjs || '-'} />
        <KV label="Adresa" value={fullAddress || '-'} />
        <KV label="Kontakt email" value={t.contactEmail || '-'} />
        <KV label="Kontakt telefon" value={t.contactPhone || '-'} />
        <KV label="Kreirano" value={new Date(t.createdAt).toLocaleDateString('sr-Latn-RS')} />
        {t.suspended && (
          <KV label="Razlog suspenzije" value={t.suspendedReason || '-'} color="#fca5a5" />
        )}
        {t.notes && <KV label="Napomena" value={t.notes} />}
      </Section>
      <Section title="Statistike">
        <KV label="Lokacija" value={String(t.locationCount ?? 0)} />
        <KV label="Klijent korisnika" value={String(t.userCount ?? 0)} />
        <KV label="Računa" value={String(t.salesCount ?? 0)} />
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ background: 'var(--color-bg-surface)', borderRadius: 10, padding: 20, border: '1px solid var(--color-border)' }}>
      <h3 style={{ margin: 0, fontSize: 13, fontWeight: 600, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 14 }}>{title}</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>{children}</div>
    </div>
  );
}

function KV({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 13 }}>
      <span style={{ color: 'var(--color-text-muted)' }}>{label}</span>
      <span style={{ color: color || 'var(--color-text-strong)', fontWeight: 500, textAlign: 'right' }}>{value}</span>
    </div>
  );
}
